module.exports = __webpack_public_path__ + "static/media/dispertador.d125df0d.png";